export default __webpack_public_path__ + "static/media/JamesCo1.536dc1ac.png";